// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "baggageDelivery-IBkHA";
var _4 = "exclusivePlate-3gZNi";
var _5 = "descriptions-2bqMy";
var _6 = "button__remove-hYT2j";
var _7 = "popup-lMmGP";
export { _1 as "__esModule", _2 as "mobile", _3 as "baggageDelivery", _4 as "exclusivePlate", _5 as "descriptions", _6 as "button__remove", _7 as "popup" }
export default { "__esModule": _1, "mobile": _2, "baggageDelivery": _3, "exclusivePlate": _4, "descriptions": _5, "button__remove": _6, "popup": _7 }
